import React from 'react';
import { Formik, Form, Field } from 'formik';
import Modal from 'react-responsive-modal';
import { Button } from '@synergy-marine-group/synergy-ui';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import { approveModalStyles } from './styles';
import confirmationShortCloseLI from '../po/queries/confirmationShortCloseLineItem';
import showAlert from '../../utils/alert';
import Loader from '../common/Loading';

const ConfirmApprovel = ({
  showApprovePopup,
  setShowApprovePopup,
  data,
  type
}) => {
  const { mutate: confirmShortClose, isLoading: isSCConfirmation } = confirmationShortCloseLI();
  const initialValues = {
    lineItemId: data.selectedLineItem.id,
    purchaseOrderId: data.selectedLineItem.purchaseOrderId,
    level: data.selectedLineItem.approveLevel,
    isApproved: type === 'Approve',
    remarks: '',
    isVendor: data.isVendor === 'true'

  };

  const confirmationShortClose = (formValues) => {
    confirmShortClose(
      { formValues },
        {
          onSuccess: () => {
            showAlert(`Short Close Request ${formValues?.isApproved ? 'Approved' : 'Rejected'} Successfully.`, 'success');
            setShowApprovePopup(false);
          },
          onError: () => {
            showAlert('Oops! Something went wrong.', 'error');
          }
        }
    );
  };

  const cancelFunction = () => {
    setShowApprovePopup(false);
  };

  return (
    <Modal
      open={showApprovePopup}
      onClose={() => setShowApprovePopup(false)}
      closeOnOverlayClick={false}
      center
      showCloseIcon={false}
      styles={approveModalStyles}
    >
      <div className="w-auto py-8 px-8 font-muli relative">
        <div className="text-center">
          <h2 className="uppercase font-montserrat pb-2 font-bold">
            {type}
            <span className="pl-1 font-bold">Item</span>
          </h2>
          <div className="font-normal pb-2">
            Are you sure you want to
            {' '}
            {type === 'Approve' ? 'approve' : 'reject'}
            {' '}
            the line item?
          </div>
          <div className="font-normal pb-2 text-black">
            <div className="text-sm font-bold text-sm">
              Sign Off (
              <span className="text-xs font-semibold">
                PO -
                {data.poNumber}
                )
              </span>
              {data?.selectedLineItem?.amount && (
                <>
                  <span className="font-muli font-bold text-secondary-900 break-normal pl-2">
                    {data?.currency}
                    {data?.selectedLineItem?.airfareValue === 'Cancelled' ? ' -' : null}
                    {Intl.NumberFormat('en-IN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }).format(data?.selectedLineItem?.amount)}
                    {data?.currency.trim() !== 'USD' && (
                      <>
                        {' (USD '}
                        {data?.selectedLineItem?.airfareValue === 'Cancelled' ? '-' : null}
                        {Intl.NumberFormat('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }).format(data?.selectedLineItem?.usdAmount) || '-'}
                        {')'}
                      </>
                    )}
                  </span>
                </>
              )}
            </div>
          </div>

          <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
              confirmationShortClose(values);
            }}
          >
            {({ values, handleChange, handleBlur, isValid }) => (
              <Form>
                <div className="font-normal pb-8">
                  <Field
                    name="remarks"
                    component={InputFieldComponent}
                    className="w-full pt-3 text-base mb-4"
                    id="remarks"
                    type="text"
                    rounded
                    autoComplete="off"
                    label="Remarks"
                    multiline
                    placeholder="Type Remarks"
                    requiredField
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.remarks}
                  />
                </div>
                <div className="flex justify-between">
                  <Button
                    className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
                    onClick={() => cancelFunction()}
                    size="large"
                    variant="outlined"
                    rounded
                    type="button"
                  >
                    Cancel
                  </Button>

                  <Button
                    className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
                    type="submit"
                    size="large"
                    variant="filled"
                    disabled={!isValid || values.remarks === ''}
                    rounded
                  >
                    {type}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      {isSCConfirmation && (
        <div className="absolute inset-0 bg-white bg-opacity-60 z-50 flex items-center justify-center">
          <Loader message="Loading" />
        </div>
      )}
    </Modal>
  );
};

export default ConfirmApprovel;
